import type { SVGProps } from 'react';
const SvgApple = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M20.843 17.145a12 12 0 0 1-1.183 2.126q-.934 1.33-1.524 1.842-.912.839-1.958.862-.753 0-1.809-.432-1.058-.431-1.947-.43-.933-.001-2.003.43-1.07.434-1.73.455-1.005.044-2.003-.885-.638-.557-1.593-1.907-1.025-1.441-1.685-3.347-.708-2.06-.708-3.99 0-2.212.957-3.811A5.6 5.6 0 0 1 5.66 6.03a5.4 5.4 0 0 1 2.71-.765q.795.002 2.095.488 1.295.487 1.661.489.275 0 1.843-.576 1.481-.532 2.505-.445 2.777.224 4.166 2.194-2.482 1.506-2.458 4.21.023 2.107 1.525 3.5.68.645 1.524.999-.183.531-.388 1.02M16.598.44q0 1.651-1.204 3.079c-.966 1.13-2.136 1.783-3.404 1.68a3 3 0 0 1-.026-.417c0-1.056.46-2.186 1.277-3.11A4.9 4.9 0 0 1 14.796.503q.94-.46 1.778-.504.024.22.023.44"
    />
  </svg>
);
export default SvgApple;
